module.exports = "<footer id=\"footer\" class=\"footer text-muted\"><!-- Copyright 2015 ForgeRock AS.\n        License terms: https://forgerock.org/cddlv1-0/ -->\n  <div class=\"container\">\n    <div>\n      Copyright © 2004-{{year}} EnerNOC, Inc. All Rights Reserved.\n    </div>\n    <div>\n      Need Help? Email <a href=\"mailto:support.enockorea@enernoc.com\">EnerNOC Support</a>, or call 1-888-EnerNOC (1-888-363-7662)\n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/footer/footer.component.html
// module id = ./src/app/core/components/footer/footer.component.html
// module chunks = main